import React, {Component} from 'react';
import {connect} from 'react-redux'
import config from '../../config'

import '../../styles/classroom/ClassroomNewbieTips.css';


class ClassroomNewbieTips extends Component {
	constructor(){
		super()
		this.state = {
			hidden: false
		}
	}

	componentWillMount(){
		const hide = localStorage.getItem('hideNewbieTips')
		if(hide){
			this.setState({hidden: true})
		}
	}

	hide(){
		this.setState({hidden: true})
		localStorage.setItem('hideNewbieTips', '1')
	}

	render(){
		if(this.state.hidden){
			return null;
		}

		const {role} = this.props
		if(role.is_lecturer){
			return (<div className="message-box newbie-tips">
					<div className="title">
						讲课须知
						<span className="close" onClick={this.hide.bind(this)}>
							<i className="iconfont icon-cuowu"></i>
						</span>
					</div>
					<div className="content">
					1. 请提前测试录音效果，直播时保持网络通畅<br />
					2. 支持单击录音和长按录音两种方式，长按录音可避免手机黑屏 <br />
					3. 一条语音为60秒，可连续录音，系统会自动发送 <br />
					4. 课件（图片、视频、音乐等）可提前上传至素材库 <br />
					5. 电脑浏览器输入网址 {config.ADMIN_BASE_URL} 登陆讲师管理后台，使用更强大的课程管理功能
					</div>
				</div>)
		}

		return (<div className="message-box newbie-tips">
				<div className="title">
					听课须知
					<span className="close" onClick={this.hide.bind(this)}>
						<i className="iconfont icon-cuowu"></i>
					</span>
				</div>
				<div className="content">
				1. 听不到声音请往下翻点击语音即可播放，并确认手机没有静音，若不行可切换网络或重新进入 <br />
				2. 遇到卡顿和加载不出，可刷新本页或重新进入 <br />
				3. 大家可在下方评论区提问和交流 <br />
				4. 课程语音永久保留，无限复听
				</div>
			</div>)
	}
}


export default connect((state) => ({
	role: state.classroom.role
}))(ClassroomNewbieTips)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomNewbieTips.js